var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('data-table',{attrs:{"columns":_vm.columns,"requesturl":"/barcodes/tat","export-csv-url":"/barcodes/tat/csv","export-excel-url":"/barcodes/tat/excel","server-params-modifier":_vm.serverParamsModifier}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }